import styled from 'styled-components';

import * as Colors from '../../attrs/colors';
import MQ from '../../attrs/mq';

export const Container = styled.div`
  background: ${Colors.GREY_20};
  color: ${Colors.GREY_50};
  padding: 1rem;
  font-size: 0.9rem;
  font-weight: bold;

  ${MQ.md`
    padding: 2rem;
  `}
`;

export const Copyright = styled.div``;

export const List = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;
  margin-bottom: 0.5rem;
`;

export const Item = styled.li`
  padding: 0.5rem 0;

  a {
    text-decoration: none;
    color: ${Colors.WHITE};

    :hover {
      color: ${Colors.WHITE};
      text-decoration: underline;
    }
  }

  ${MQ.md`
    display: inline-block;
    padding-right: 1rem;

    :last-child {
      padding-right: 0;
    }
  `}

  ${MQ.lg`
    padding: 0 1rem 0 0;
  `}
`;

export const IconsItem = styled(Item)`
  display: inline-block;
  padding-right: 1rem;

  :last-child {
    padding-right: 0;
  }
`;
